/**
 * O check do valor que o e-mail trouxe (`TP-072`), ao lado do item do cadastro que espera confirmação: o valor e um ✓.
 * Confirmar grava o valor como o da pessoa (a mesma escrita da triagem), e o item passa a provado. Errado não se corrige
 * aqui: a fonte abre a mensagem na triagem, onde se corrige o campo.
 */

import CheckOutlined from '@mui/icons-material/CheckOutlined';
import IconButton from '@mui/material/IconButton';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { confirmarValorDoEmail, invalidarOQueAProvaMuda } from './api';
import type { SugestaoDoItem } from './tipos';

export function ConfirmarDoEmail({
  casoId,
  rotulo,
  sugestao,
}: {
  casoId: string;
  rotulo: string;
  sugestao: SugestaoDoItem;
}): React.JSX.Element | null {
  const cliente = useQueryClient();
  const { campoId, ticketId, valor } = sugestao;
  const confirmar = useMutation({
    mutationFn: () => confirmarValorDoEmail(ticketId ?? '', campoId ?? '', valor ?? ''),
    onSuccess: () => invalidarOQueAProvaMuda(cliente, casoId, 'documentos'),
  });

  if (!campoId || !ticketId || valor === null) return null;

  return (
    <span className="inline-flex items-baseline gap-1 text-[var(--tinta-2)]">
      <span className="text-[var(--tinta-3)]">e-mail:</span>
      <span className="max-w-[18rem] truncate" title={valor}>
        {valor}
      </span>
      <IconButton
        size="small"
        aria-label={`Confirmar ${rotulo} do e-mail`}
        title="Confirmar o valor do e-mail"
        disabled={confirmar.isPending}
        onClick={() => {
          confirmar.mutate();
        }}
        sx={{ p: 0.25 }}
      >
        <CheckOutlined sx={{ fontSize: '1rem' }} />
      </IconButton>
      {confirmar.isError && <span className="text-[var(--sinal-atencao)]">não deu para confirmar</span>}
    </span>
  );
}
